// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"b015f8af","216":"01834d81","319":"a40f037c","400":"c654c85e","444":"86cf2882"}[chunkId] + ".chunk.js";
};